import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["aria-label"]

import { computed, ref, useSlots } from "vue";
import Popper from "vue3-popper";
import DsIcon from "../icon/ds-icon.vue";
import type { SvgIcons } from "../icon/types";
import type { Placement } from "../types/popper";
import DsButton from "../button/ds-button.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-tooltip',
  props: {
    delay: { default: 300 },
    placement: { default: "top" },
    icon: { default: "info" },
    isInStorybook: { type: Boolean, default: false },
    iconWidth: {},
    iconHeight: {},
    show: { type: Boolean, default: undefined },
    arrow: { type: Boolean, default: true },
    hover: { type: Boolean, default: true },
    locked: { type: Boolean, default: false },
    hasTrigger: { type: Boolean, default: true },
    hasCloseButton: { type: Boolean, default: false },
    ariaLabelValue: {}
  },
  setup(__props: any, { expose: __expose }) {

const popperRef = ref<HTMLElement>(null);

__expose({
    popperRef,
});

const props = __props;

const slots = useSlots();
const hasCustomTrigger = computed(() => !!slots["custom-trigger"]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popper), {
    arrow: _ctx.arrow,
    placement: _ctx.placement,
    show: _ctx.show,
    hover: _ctx.hover,
    locked: _ctx.locked,
    "close-delay": _ctx.delay,
    class: "ds-tooltip",
    "z-index": "600"
  }, {
    content: _withCtx(({ close }) => [
      (_ctx.hasCloseButton)
        ? (_openBlock(), _createBlock(DsButton, {
            key: 0,
            type: "primary",
            "icon-right": "cross",
            size: "sm",
            onClick: close,
            class: "ds-tooltip__close-button"
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "ds-tooltip__content",
        role: "tooltip",
        ref_key: "popperRef",
        ref: popperRef
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 512)
    ]),
    default: _withCtx(() => [
      (!hasCustomTrigger.value && _ctx.hasTrigger)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ds-tooltip__link",
            "aria-label": _ctx.ariaLabelValue
          }, [
            _createVNode(DsIcon, {
              "is-in-storybook": props.isInStorybook,
              name: props.icon,
              width: _ctx.iconWidth,
              height: _ctx.iconHeight
            }, null, 8, ["is-in-storybook", "name", "width", "height"])
          ], 8, _hoisted_1))
        : (_ctx.hasTrigger)
          ? _renderSlot(_ctx.$slots, "custom-trigger", { key: 1 })
          : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["arrow", "placement", "show", "hover", "locked", "close-delay"]))
}
}

})